import loadable from '@loadable/component';

const StickyAssets = loadable(() =>
  import(/* webpackChunkName: "invitato-sticky-assets" */ './index'),
);

export default StickyAssets;
